export default __webpack_public_path__ + "static/t2-a7d83c20ba713da4512706cd41214730.webp";